import { combineReducers } from 'redux';

import useReducer from "./userReducer";
import profileReducer from "./profileReducer";
import countriesReducer from "./countriesReducer";

const rootReducer = combineReducers({
  userState: useReducer,
  profileState: profileReducer,
  countriesState: countriesReducer,
});

export default rootReducer;
